const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '450px',
    tabletL: '775px',
    tablet: '1023px',
 
    laptop: '924px',
    laptopL: '1024px',
    desktop: '2560px'
}
//#cb0c9f pour les border e9ecef
//#cb0c9f; texte en hover b
// les btn pour filter #d2d6da pou border par defaut avant le hover et cb0c9f pour hover  et #495057 pour le texte

const theme = {
    colors: {
        body: "#fdfdfd",
        textBody: "#3a4c6b",
        textFormControle:"#495057",
        text: "#000000",
        content: "#ffffff",
        lightBlack: "#344767 !important",
        lightBlue: "#809FB8 !important",
        gray: "#dee2e6",
        younovGray: "#b7c0ce",
        borderGray:"#e9ecef",
        sendBtn : "#6C5CE7",
        cancelBtn : "#809FB8",
        btnBorder: "#cb0c9f",
        btnHover: '#F1F4F9',
        primary: "#1995ee",/*#1995ee*/
     /*   primary: "#2174B9",*/
        secondary: "#344767",
        success: "#82d616",
        danger: '#ea0606',
        warning : '#EECC5A',

        redLight : "#EE5A5A66",
        greenLight : "#55EFC466",
        green: "#95dc39",
        orangeLight : "#EECC5A66",
        purple: "#C8B0E6"

    },
    status: {
        background: {
            
            NEW : "#F5FBFF",
           
            ERROR: "#EE5A5A66",
           
        },
        text: {
          
            NEW : "#F5FBFF",
            ERROR: "#EE5A5A66",
           
        }
    },
    device : {
        mobileS: `(min-width: ${size.mobileS})`,
        mobileM: `(max-width: ${size.mobileM})`,
        mobileL: `(max-width: ${size.mobileL})`,
        tablet: `(max-width: ${size.tablet})`,
        tabletL: `(max-width: ${size.tabletL})`,
        laptop: `(min-width: ${size.laptop})`,
        laptopL: `(min-width: ${size.laptopL})`,
        desktop: `(min-width: ${size.desktop})`,
        desktopL: `(min-width: ${size.desktop})`
    },
    size : {
        mobileS: '320px',
        mobileM: '375px',
        mobileL: '435px',
        tabletL: '775px',
        laptop: '1024px',
        laptopL: '1160px',
        desktop: '2560px'
    }
}

export default theme;